import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { AppStartListening } from './helpers/types';
import { registerCaptionBlockingListeners } from './listeners/captionBlockingListeners';
import { registerCaptionDisconnectListeners } from './listeners/captionDisconnectListeners';
import { registerCaptionOwnershipListeners } from './listeners/captionOwnershipListeners';
import { registerCaptionSessionListeners } from './listeners/captionSessionListeners';
import { registerCaptionStatusListeners } from './listeners/captionStatusListeners';

// Captions lifecycle is split on purpose:
// - callCaptionsSlice extraReducers: sync cleanup (lines, startedSessionIds)
// - this middleware: demand-driven start/stop API calls and hearing-disconnect clears
//
// User toggles go through toggleCaptionsThunk, not a setCaptionsEnabled listener,
// to avoid racing duplicate startCaptionsSessionThunk dispatches.
//
// Stop-captions is demand-driven only. Lifecycle actions (voice-session
// finish/reset/teaming leave, resetCallCaptions) clear local state in the slice
// and never call the stop API — voice-session teardown covers call end.
//
// Registration order is load-bearing. Ownership clears remote demand in its
// synchronous prefix. The status listener is registered after that so a takeover
// does not report On for a peer cleared in the same turn.

const listenerMiddleware = createListenerMiddleware();
const startListening = listenerMiddleware.startListening as AppStartListening;

registerCaptionSessionListeners(startListening);
registerCaptionOwnershipListeners(startListening);
registerCaptionDisconnectListeners(startListening);
registerCaptionStatusListeners(startListening);
registerCaptionBlockingListeners(startListening);

export const callCaptionsListenerMiddleware = listenerMiddleware.middleware;
